import React, { PropTypes } from 'react';
import { TableRow, TableRowColumn } from 'material-ui';

const GenericTableRow = props => {
  const {
    leftIcon,
    leftIconStyle,
    middleInfo,
    middleInfoStyle,
    thirdColumn,
    rightIcon,
    rightIconStyle,
    outerTableStyle,
    rowId
  } = props;

  return (
    <TableRow style={outerTableStyle} id={rowId}>
      <TableRowColumn style={leftIconStyle}>
        {leftIcon}
      </TableRowColumn>
      <TableRowColumn style={middleInfoStyle} data-cy={`midrow-${rowId}`}>
        {middleInfo}
      </TableRowColumn>
      {
        thirdColumn ?
        <TableRowColumn style={rightIconStyle}>
          {rightIcon}
        </TableRowColumn> : ''
      }
    </TableRow>
  );
};

GenericTableRow.propTypes = {
  leftIcon: PropTypes.object,
  leftIconStyle: PropTypes.object,
  middleInfo: PropTypes.object,
  middleInfoStyle: PropTypes.object,
  thirdColumn: PropTypes.bool,
  rightIcon: PropTypes.object,
  rightIconStyle: PropTypes.object,
  outerTableStyle: PropTypes.object,
  rowId: PropTypes.string
};

export default GenericTableRow;



// WEBPACK FOOTER //
// ./src/app/components/signup/generic-table-row.jsx